/**
 * 「AIをつなぐ」の絵の日本語（en.connectPics.ts と同じキー・決まりもそちら）。
 * 押す所の名前は英語のまま（ChatGPT・Claude の画面の言葉 = サイトの手順のページの太字と同じ）
 */
import type { enConnectPics } from './en.connectPics';

export const jaConnectPics: Record<keyof typeof enConnectPics, string> = {
  'home.step.connect.pics.label': 'つなぎ方の流れ',
  'home.step.connect.pics.note': '1 段ずつ AI が教えてくれます。絵はイラストで、実際の表示は少し違うことがあります。',
  'home.step.connect.pics.paste': '{ai}に文を貼って送る',
  'home.step.connect.pics.chatgptAdd': 'Plugins → + → Add custom MCP server',
  'home.step.connect.pics.claudeAdd': 'Customize → Connectors → Add custom connector',
  'home.step.connect.pics.allow': '{product}にログインして Allow を押す',
  'home.step.connect.pics.chatgptUse': '新しいメッセージで @ を打ち、{product}を選ぶ',
  'home.step.connect.pics.claudeUse': '+ → Connectors で{product}をオンにする',
  'home.step.connect.pics.runs': '{ai}がつなぐコマンドを実行する',
  'home.step.connect.pics.ask': '作りたいものを頼む。この画面は「つないだ」に変わる',
  'home.step.connect.pics.alt.paste': '{ai}の入力欄にコピーした文を貼り、送るボタンに印',
  'home.step.connect.pics.alt.chatgptAdd': 'ChatGPT の設定。横のメニューの Plugins、+ のメニューの Add custom MCP server に印',
  'home.step.connect.pics.alt.claudeAdd': 'Claude の設定。Customize の Connectors、+ Add のメニューの Add custom connector に印',
  'home.step.connect.pics.alt.allow': '{product}のページ「Allow {ai} to use {product}?」。Allow のボタンに印',
  'home.step.connect.pics.alt.chatgptUse': 'ChatGPT の入力欄に @ を打ち、出た一覧の{product}に印',
  'home.step.connect.pics.alt.claudeUse': 'Claude の入力欄の + のメニュー、Connectors、{product}のスイッチをオン',
  'home.step.connect.pics.alt.runs': '{ai}が{product}のつなぐコマンドを実行し、チェックの印',
  'home.step.connect.pics.alt.ask': '{ai}に頼みを打ち、ダッシュボードの段が「つないだ」に'
};
